module.exports = __webpack_public_path__ + "img/logo_bmmc.4cf69dcb.png";